import { WorkspaceAppPath } from './workspaceNames';

export const transactionIntelligenceVisualTitles = [
  'P: Industry Classification Slicer',
  'P: Primary Industry Slicer',
  'P: Sub Industries Slicer',
  'P: Industry Verticals Slicer',
  'P: Region Slicer',
  'P: Sub Region Slicer',
  'P: Country Slicer',
  'P: Deal Date Dropdown Slicer',
  'P: Deal Date Slider Slicer',
  'P: Deal Size Range Slicer',
  'P: Deal Size Slider Slicer',
  'P: Deal Type Slicer',
  'P: Asset Class',
  'P: Asset Type',
  'P: TVPI Slicer',
  'P: DPI Slicer',
  'P: RVPI Slicer',
  'P: IRR Slicer',
  'P: Deal Type II',
  'V: EV Entry Slicer',
  'V: Net Debt / Ebitda Entry Slicer',
  'V: EV / Revenue Entry Slicer',
  'V: EV / Ebitda Entry Slicer',
  'V: ebitda margin Entry Slicer',
  'V: loan to value Entry Slicer',
  'V: Revenue Growth Slicer',
  'V: Ebitda Growth Slicer',
  'V: Net Debt Growth Slicer',
  'V: Exit',
  'V: Exit Type',
  'V: Exit Date Slider Slicer',
  'Company Description Slicer',
  'P: Deal Date Year Slicer',
];

export const termIntelligenceVisualTitles = [
  'Asset Class',
  'Vintage',
  'Fund Size',
  'Primary Region Focus',
  'Waterfall Type',
];

export const futureFundsVisualTitles = [
  'Strategy',
  'Sector',
  'Prior fund closed size',
  'Fund manager',
  'Fund manager location',
  'Dry powder %',
  'Deployment speed %',
  'Prior fund service provider',
  'Firm size',
  'Prior fund domicile',
  'Fund cycle status',
  'Dry power status',
  'ESG fund label',
  'Firm AUM',
  'Estimated fund launch date',
];

export const visualTitles = {
  [WorkspaceAppPath.TransactionIntelligenceFreeTrial]: transactionIntelligenceVisualTitles,
  [WorkspaceAppPath.TransactionIntelligence]: transactionIntelligenceVisualTitles,
  [WorkspaceAppPath.TermIntelligence]: termIntelligenceVisualTitles,
  [WorkspaceAppPath.FutureFunds]: futureFundsVisualTitles,
};
